import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { PartnerStrip } from "@/components/PartnerStrip";
import { ValueStrip } from "@/components/ValueStrip";
import { WhoWeAre } from "@/components/WhoWeAre";
import { Ecosystem } from "@/components/Ecosystem";
import { Services } from "@/components/Services";
import { HospitalOwners } from "@/components/HospitalOwners";
import { WhyUs } from "@/components/WhyUs";
import { Patients } from "@/components/Patients";
import { Connect } from "@/components/Connect";
import { Knowledge } from "@/components/Knowledge";
import { Regional } from "@/components/Regional";
import { EcosystemCta } from "@/components/EcosystemCta";
import { EnquiryForm } from "@/components/EnquiryForm";
import { SocialFinal } from "@/components/SocialFinal";
import { ExitPopup } from "@/components/ExitPopup";
import { WhatsAppFab } from "@/components/WhatsAppFab";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-white">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <PartnerStrip />
        <ValueStrip />
        <WhoWeAre />
        <Ecosystem />
        <Services />
        <HospitalOwners />
        <WhyUs />
        <Patients />
        <Connect />
        <Knowledge />
        <Regional />
        <EcosystemCta />
        <EnquiryForm />
        <SocialFinal />
      </main>
      <ExitPopup />
      <WhatsAppFab />
    </div>
  );
}
